"use strict";

exports.__esModule = true;
exports.ElementEditorDragPreview = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Theme = require("../../Theme");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var ElementPreview = _styledComponents["default"].div.withConfig({
  displayName: "ElementEditorDragPreview__ElementPreview",
  componentId: "sc-dem2d2-0"
})(["display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.08);opacity:0.9;outline:", " solid 1px;outline-offset:1px;"], (0, _Theme.val)("selectedBorderColor"));
var ElementEditorDragPreview = exports.ElementEditorDragPreview = /*#__PURE__*/function (_React$PureComponent) {
  function ElementEditorDragPreview() {
    return _React$PureComponent.apply(this, arguments) || this;
  }
  _inheritsLoose(ElementEditorDragPreview, _React$PureComponent);
  var _proto = ElementEditorDragPreview.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      type = _this$props.type,
      width = _this$props.width,
      height = _this$props.height,
      render = _this$props.render;
    var style = {
      width: width,
      height: height
    };
    return /*#__PURE__*/_react["default"].createElement(ElementPreview, {
      style: style
    }, render({
      type: type,
      width: width,
      height: height
    }));
  };
  return ElementEditorDragPreview;
}(_react["default"].PureComponent);
ElementEditorDragPreview.defaultProps = {
  width: 128,
  height: 64
};